import React, { useCallback, useState } from 'react';
import { Box, Tab, Tabs } from '@mui/material';
import { TabContext, TabPanel } from '@mui/lab';
import ApprovalLevelSection from './ApprovalLevelSection';
import ApprovalLevelLineItemSection from './ApprovalLevelLineItemSection';
import SafetyCheckMotion from './SafetyCheckMotion';
import FinalActionMotion from './FinalActionMotion';
import FinalLineActionMotion from './FinalLineActionMotion';
import IPCheckSection from './IPCheckSection';

import commonStyles from 'styles/common.module.scss';

enum WrapUpAction {
  ApprovalLevel = 'ApprovalLevel',
  ApprovalLevelLineItem = 'ApprovalLevelLineItem',
  SafetyCheck = 'SafetyCheck',
  IPCheck = 'IPCheck',
  FinalActionVote = 'FinalActionVote',
  FinalLineActionVote = 'FinalLineActionVote',
}

const WrapUpActions: React.FunctionComponent = () => {
  const [activeTab, setActiveTab] = useState<string>(WrapUpAction.ApprovalLevel);

  const handleTabChange = useCallback((_: any, value = WrapUpAction.ApprovalLevel) => {
    setActiveTab(value);
  }, []);

  return (
    <TabContext value={activeTab}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={activeTab}
          onChange={handleTabChange}
          indicatorColor={'primary'}
          textColor={'primary'}
          variant={'scrollable'}
        >
          <Tab value={WrapUpAction.ApprovalLevel} label={'Approval Level'} className={commonStyles.tab} />
          <Tab
            value={WrapUpAction.ApprovalLevelLineItem}
            label={'Approval Level Line Item'}
            className={commonStyles.tab}
          />
          <Tab value={WrapUpAction.SafetyCheck} label={'Safety Check'} className={commonStyles.tab} />
          <Tab value={WrapUpAction.IPCheck} label={'IP Check'} className={commonStyles.tab} />
          <Tab value={WrapUpAction.FinalActionVote} label={'Final Action Vote'} className={commonStyles.tab} />
          <Tab value={WrapUpAction.FinalLineActionVote} label={'Final Line Action Vote'} className={commonStyles.tab} />
        </Tabs>
      </Box>
      <TabPanel className={commonStyles.tabPanel} value={WrapUpAction.ApprovalLevel}>
        <ApprovalLevelSection />
      </TabPanel>
      <TabPanel className={commonStyles.tabPanel} value={WrapUpAction.ApprovalLevelLineItem}>
        <ApprovalLevelLineItemSection />
      </TabPanel>
      <TabPanel className={commonStyles.tabPanel} value={WrapUpAction.SafetyCheck}>
        <SafetyCheckMotion />
      </TabPanel>
      <TabPanel className={commonStyles.tabPanel} value={WrapUpAction.IPCheck}>
        <IPCheckSection />
      </TabPanel>
      <TabPanel className={commonStyles.tabPanel} value={WrapUpAction.FinalActionVote}>
        <FinalActionMotion />
      </TabPanel>
      <TabPanel className={commonStyles.tabPanel} value={WrapUpAction.FinalLineActionVote}>
        <FinalLineActionMotion />
      </TabPanel>
    </TabContext>
  );
};

export default WrapUpActions;
